let userData_store = {
  /* english */
  locale: 'en-us',
  bilingualLocale: 'en-us',
  bilingualMode: false,

  /* spanish */
  // locale: 'es-mx',
  // bilingualLocale: 'es-mx',
  // bilingualMode: false,

  /* bilingual */
  // locale: 'en-us',
  // bilingualLocale: 'es-mx',
  // bilingualMode: true,
};

export function getUserData(){
  return userData_store;
}

//TODO: THE FOLLOWING CODE SHOULDN'T BE DUPLICATED FROM LEXA-APP
const IPA2AMIRABET_EN_US_DOUBLE = new Map([
  ['aʊ', 'α'],
  ['aɪ', 'γ'],
  ['aI', 'γ'],
  ['tʃ', 'x'],
  ['tS', 'x'],
  ['eɪ', 'a'],
  ['eI', 'a'],
  ['dʒ', 'j'],
  ['dZ', 'j'],
  ['oʊ', 'o'],
  ['ɔɪ', 'ω']
]);

const IPA2AMIRABET_EN_US_SINGLE = new Map([
  ['̩', ''],
  ['b', 'b'],
  ['d', 'd'],
  ['f', 'f'],
  ['ɡ', 'g'],
  ['g', 'g'],
  ['h', 'h'],
  ['i', 'i'],
  ['ʤ', 'j'],
  ['k', 'k'],
  ['l', 'l'],
  ['ɫ', 'l'],
  ['m', 'm'],
  ['n', 'n'],
  ['N', 'n'],
  ['p', 'p'],
  ['s', 's'],
  ['t', 't'],
  ['u', 'u'],
  ['v', 'v'],
  ['w', 'w'],
  ['ʧ', 'x'],
  ['c', 'x'],
  ['j', 'y'],
  ['z', 'z'],
  ['æ', 'æ'],
  ['&', 'æ'],
  ['ð', 'ð'],
  ['D', 'ð'],
  ['ŋ', 'ŋ'],
  ['9', 'ŋ'],
  ['ɑ', 'ɑ'],
  ['ɒ', 'ɑ'],
  ['ɔ', 'ɔ'],
  ['ɛ', 'ɛ'],
  ['ɝ', 'ɝ'],
  ['ɚ', 'ɝ'],
  ['3', 'ɝ'],
  ['ɪ', 'ɪ'],
  ['I', 'ɪ'],
  ['ɹ', 'ɹ'],
  ['r', 'ɹ'],
  ['ʃ', 'ʃ'],
  ['S', 'ʃ'],
  ['ʊ', 'ʊ'],
  ['V', 'ʊ'],
  ['U', 'ʊ'],
  ['ʌ', 'ʌ'],
  ['ə', 'ʌ'],
  ['ʒ', 'ʒ'],
  ['Z', 'ʒ'],
  ['θ', 'θ'],
  ['T', 'θ']
]);

export function ipaToAmirabet(phon){
  let ipa = phon.replace(/\//g, "").replace(/\ˈ/g, "");
  let result = '';

  while(ipa.length > 0){
    let match = '';
    match = IPA2AMIRABET_EN_US_DOUBLE.get(ipa.substring(0,2));
    if(match){
      result += match;
      ipa = ipa.substring(2);
      continue;
    }
    match = IPA2AMIRABET_EN_US_SINGLE.get(ipa.substring(0,1));
    if(match){
      result += match;
      ipa = ipa.substring(1);
      continue;
    }
    console.log("NOT FOUND",ipa.substring(1));
    ipa = ipa.substring(1);
  }
  return result;
}